import { Select, SelectProps } from '@mui/material';

import { InputBaseStyled } from './AdornmentSelect.styled';

export const AdornmentSelect = ({ children, ...otherProps }: SelectProps) => {
  return (
    <Select {...otherProps} input={<InputBaseStyled />}>
      {children}
    </Select>
  );
};
